import React from 'react'
import Table from 'react-bootstrap/esm/Table';
import { Button, Grid } from '@mui/material';
import { TechnicalEvaluationCriteriaSlideField, TechnicalEvaluationCriteriaSlideTooltip } from '../../helpers/DossierFieldConstants';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import '../../css/template.css'
import { getSlideTooltip } from '../../helpers/Helpers';
import MyRichTextEditor from '../MyRichTextEditor';


/**
 * @typedef {Object} TechnicalEvaluationCriteriaSlideProps
 * @property {CpscRequest} cpscRequest
 * @property {updateDossierCallback} setDossier
 * @property {Boolean} readOnly
 * @property {number} dossierRefreshCount
 */

/**
 * @param {TechnicalEvaluationCriteriaSlideProps}  props
 * @return {import('react').ReactElement}
 */
function TechnicalEvaluationCriteria(props) {
    /** @type TechnicalEvaluationCriteria */
    let emptyTechnicalEvaluationCriterion = {

        serialNo: props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria == null || props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.length === 0 ? 1 : Math.max.apply(Math, props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.map(function (o) { return o.serialNo; })) + 1,
        description: "Technical Criteria",
        weight: 0,

    }
   
    let totalTechnicalWeightSum = props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.reduce((partialSum, a) => partialSum + Number(a.weight), 0);

    const addNewTechnicalCriterion = () => {
        props.setDossier({ ...props.cpscRequest.dossier, technicalEvaluationCriteriaSlide: { ...props.cpscRequest.dossier.technicalEvaluationCriteriaSlide, technicalEvaluationCriteria: [...props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria, emptyTechnicalEvaluationCriterion] } })
    }

    /** @param {number} serialNo, @param {string} name, @param {any} value  */
    const updateTechnicalCriterionDataField = (serialNo, name, value) => {
        props.setDossier({ ...props.cpscRequest.dossier, technicalEvaluationCriteriaSlide: { ...props.cpscRequest.dossier.technicalEvaluationCriteriaSlide, technicalEvaluationCriteria: props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.map(inst => inst.serialNo !== serialNo ? inst : { ...inst, [name]: value })} })
    }

    /** @param {number} serialNo  */
    const deleteTechnicalCriterion = (serialNo) => {
        props.setDossier({
            ...props.cpscRequest.dossier, technicalEvaluationCriteriaSlide: {
              ...props.cpscRequest.dossier.technicalEvaluationCriteriaSlide, technicalEvaluationCriteria: props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.filter(inst => inst.serialNo !== serialNo).map((inst, index) => ({ ...inst, serialNo: index + 1 }))
            }
          })
    }


 /** @param {string} name, @param {any} value  */
 const updateDataFieldValue = (name, value) => {
    props.setDossier({ ...props.cpscRequest.dossier, technicalEvaluationCriteriaSlide: { ...props.cpscRequest.dossier.technicalEvaluationCriteriaSlide, [name]: value } })
  }
    return (
      
        <div style={{ padding: 10 }}>
            <span style={{ float: 'right' }}>
                <Button onClick={addNewTechnicalCriterion} variant='contained' color='success' disabled={props.readOnly}>Add New Technical Criterion</Button>
            </span>
            <br />
            <br />
            <Grid container>
                <Grid item xs={12} sm={12} lg={12} >
                    <Table responsive striped bordered>
                        <thead>
                            <tr style={{ fontSize: '10px', }}>
                                <th >SN</th>
                                <th style={{ width: '60%' }}>Description</th>
                                <th style={{ width: '20%' }}>Weight%</th>

                                <th style={{ width: '20%', textAlign: 'center' }}>Actions</th>

                            </tr>
                        </thead>
                        <tbody>
                            {props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.sort((a, b) => a.serialNo < b.serialNo ? -1 : 1).map((item, index) => {
                                return <tr  key={index}>
                                    <td>{item.serialNo}</td>
                                    <td style={{ width: '60%' }}>
                                        <textarea id='description' onChange={(e) => updateTechnicalCriterionDataField(item.serialNo, e.target.id, e.target.value)}
                                            value={item.description} className='form-control' style={{ width: '100%', height: '31px' }} name='description' required disabled={props.readOnly} />
                                    </td>
                                    <td style={{ width: '20%' }}>
                                        <input id='weight' onChange={(e) => updateTechnicalCriterionDataField(item.serialNo, e.target.id, Math.round(Number(e.target.value)))}
                                            value={item.weight} type="number" className="form-control input-font bold" placeholder="Weight" required max={100} min={1} disabled={props.readOnly} />
                                    </td>
                                    <td style={{ minWidth: 20, textAlign: 'center' }}>
                                        <Button variant='contained' color='info' disabled={props.readOnly} onClick={() => deleteTechnicalCriterion(item.serialNo)}>Delete</Button>
                                    </td>
                                </tr>
                            })}
                            {props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.technicalEvaluationCriteria.length === 0 ? <tr>
                                <td colSpan={4}><p className=' text-center'> No record available...</p></td>


                            </tr> : ''}

                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={2}> Total</td>
                                <td>
                                    {totalTechnicalWeightSum}</td>
                                <td> </td>
                            </tr>
                        </tfoot>
                    </Table>
                </Grid>
            </Grid>
            <br />

            <div className="form-group">
                <label className=' title-label' > {getSlideTooltip(props.cpscRequest, TechnicalEvaluationCriteriaSlideTooltip.supportingInformation)}Supporting Information <span className='important'>*</span></label>
          <MyRichTextEditor readOnly={props.readOnly} editorHtmlString={props.cpscRequest.dossier.technicalEvaluationCriteriaSlide.supportingInformation} updateEditorHtmlString={editorHtmlString => updateDataFieldValue(TechnicalEvaluationCriteriaSlideField.supportingInformation, editorHtmlString)} />  
       </div>
        </div>
    )
}

export default TechnicalEvaluationCriteria